﻿import { useState } from 'react';
import * as React from 'react';

import { Button, ButtonProps, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';

import 'components/GMetrixButton/GMetrixButton.scss';

interface GMetrixButtonProps extends ButtonProps {
    className?: string;
    disabled?: boolean;
    disabledTimeout?: number;
    iconClass?: string;
    infoTitle?: string;
    onClick?: (e: any) => any;
    variant?: Variant;
}

function GMetrixButton(
    {
        className,
        disabled,
        disabledTimeout = 0,
        iconClass,
        infoTitle,
        onClick,
        type = 'button',
        variant = '',
        ...otherProps
    }: GMetrixButtonProps
) {

    const [temporaryDisabled, setTemporaryDisabled] = useState(false);

    // Icon-only buttons have no visible text, so screen readers need an explicit
    // accessible name. Fall back to the tooltip text (infoTitle) when no aria-label
    // was supplied by the caller.
    const isIconOnly = !otherProps.children && !!iconClass;
    const ariaLabel = (otherProps as { 'aria-label'?: string })['aria-label'] ?? (isIconOnly ? infoTitle : undefined);

    const buttonElement = (
        <Button
            onClick={e => {

                if (disabledTimeout > 0) {

                    setTemporaryDisabled(true);
                    setTimeout(() => setTemporaryDisabled(false), disabledTimeout);

                }
                if (onClick) {

                    onClick(e);

                }

            }}
            className={`${className} text-nowrap`}
            disabled={disabled || temporaryDisabled}
            type={type}
            variant={variant}
            {...otherProps}
            aria-label={ariaLabel}
        >
            {iconClass && (
                <i aria-hidden="true" className={`${iconClass} ${otherProps.children ? 'me-2 align-baseline' : 'm-1'}`} />
            )}
            {otherProps.children}
        </Button>
    );

    return infoTitle ? (
        <OverlayTrigger
            overlay={props => (
                <Tooltip id="button-tooltip" {...props}>
                    {infoTitle}
                </Tooltip>
            )}
            delay={{ hide: 250, show: 250 }}
            placement="top"
        >
            {buttonElement}
        </OverlayTrigger>
    ) : (
        buttonElement
    );

}

export { GMetrixButton };
